import HttpClient from "../helpers/HttpClient"
import CompanyDescription, { CompanyDescriptionDto } from "./CompanyDescription"


class CompanyDescriptionService {
    httpClient: HttpClient<CompanyDescription,
        CompanyDescriptionDto> = new HttpClient<CompanyDescription, CompanyDescriptionDto>(CompanyDescription)

    async get() {
        return this.httpClient.get("/accounts/company-descriptions")
    }
}

const instance = new CompanyDescriptionService()
export default instance


// WEBPACK FOOTER //
// ./src/state/companyDescription/CompanyDescriptionService.ts